export default __webpack_public_path__ + "static/NBInternationalPro-Bold-2d0cb85c4a52cda084662ef2e7556ed2.woff2";